'use strict';

import angular from 'angular';

class PhotoResource {
  constructor($q, $http, userModel, utils) {
    'ngInject';

    this.$q = $q;
    this.$http = $http;
    this.userModel = userModel;
    this.utils = utils;
  }

  uploadFromSocialNetwork(photo) {
    const userId = this.userModel.item.id;
    const url = this.utils.getApiUrl(`/photos/${userId}/upload/file?type=social`);

    return new this.$q((resolve, reject) => {
      this.$http.post(url, photo)
        .then(response => resolve(response.data))
        .catch(reject);
    });
  }

  makeMain(photoId) {
    return new this.$q((resolve, reject) => {
      const userId = this.userModel.item.id;
      const url = this.utils.getApiUrl(`/photos/${userId}/set_main/${photoId}`);

      this.$http.post(url)
        .then(resolve)
        .catch(reject);
    });
  }

  rotatePhoto(photoData) {
    return new this.$q((resolve, reject) => {
      const userId = this.userModel.item.id;
      const url = this.utils.getApiUrl(`photos/${userId}/rotate`);

      this.$http.post(url, photoData)
        .then(resolve)
        .catch(reject);
    });
  }

  cropPhoto(photoData) {
    return new this.$q((resolve, reject) => {
      const userId = this.userModel.item.id;
      const url = this.utils.getApiUrl(`photos/${userId}/crop`);

      this.$http.post(url, photoData)
        .then((response) => resolve(response.data))
        .catch(reject);
    });
  }

  deletePhoto(photoId) {
    return new this.$q((resolve, reject) => {
      const userId = this.userModel.item.id;
      const url = this.utils.getApiUrl(`photos/${userId}/delete/${photoId}`);

      this.$http.delete(url)
        .then(resolve)
        .catch(reject);
    });
  }
}

export default angular
  .module('resources.photo', [])
  .service('photoResource', PhotoResource)
  .name;



// WEBPACK FOOTER //
// ./app/src/resources/photo_resource.js